import { Star } from 'lucide-react';
import { ProviderRatingProps } from '../types';
import { formatRating } from '../utils';

export const ProviderRating = ({ rating, children }: ProviderRatingProps) => {
  return (
    <div className="flex items-center justify-center gap-3 pt-0.75 px-2 pb-1">
      {children}
      <div className="flex items-center justify-center gap-2.25">
        <span className="font-mono text-xs font-medium leading-[144%] tracking-[1.2px] uppercase text-white">
          {formatRating(rating)}
        </span>
        <Star className="size-3 fill-white" />
      </div>
    </div>
  );
};
